import { OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { DashboardService } from '../../dashboard';
import '../../rxjs-operators';
import * as moment from 'moment-timezone';
import { ErrorHandlerService } from '../../services';
import { PagerService } from './pagination.service';
import { ConfirmationService } from 'primeng/primeng';
import { DateTimeConverstionService } from '../../services/index';
import { DomSanitizer } from '@angular/platform-browser';
import { DASHBOARDENDPOINTS } from 'app/environment';
var CourseaccountComponent = /** @class */ (function () {
    function CourseaccountComponent(sanitizer, dashboardService, pagerService, errorHandlerService, confirmationService, router, timeZoneConverstionService) {
        this.sanitizer = sanitizer;
        this.dashboardService = dashboardService;
        this.pagerService = pagerService;
        this.errorHandlerService = errorHandlerService;
        this.confirmationService = confirmationService;
        this.router = router;
        this.timeZoneConverstionService = timeZoneConverstionService;
        this.allcourses = [];
        this.allcoursesdata = {};
        this.userId = '';
        this.balance = 0;
        this.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone.toString();
        this.msgTitle = "";
        this.msgContent = "";
        this.popUp = false;
        this.showSpinner = false;
        this.showOnlyOverlay = false;
        this.showErrorModalDialog = false;
        this.showErrorMessages = [""];
        this.showErrorMessageTitle = "Error!";
        this.showErrorMessageWidthInPercentage = "20%";
        this.courseRecordings = [];
        this.showCourseRecordings = false;
        this.parentWindowHeight = 0;
        this.parentWindowWidth = 0;
        this.courseRecordingsWindowHeight = 0;
        this.courseRecordingsWindowWidth = 0;
        this.SessionMsg = "Please wait... Loading sessions...";
        this.endPoint = "";
        this.subscriptions = [];
        // pager object
        this.pager = {};
        this.currentPage = 1;
        // paged items
        this.pagedItems = [];
        this.addCoHostShow = false;
        this.userToresults = [];
        this.usersTo = [];
        this.checked = false;
        this.addCouponCode = {
            couponCode: "",
            discountPercentage: "",
            target: "SESSION",
            targetId: 0,
            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone.toString(),
            validityUpto: ""
        };
        this.promoAdded = false;
        this.recordingNewName = "";
        this.videoIdForRename = 0;
        this.recordingObj = {
            sessionId: 0,
            videoId: 0,
            renamedVideo: ""
        };
        this.hostOrSpeaker = "";
        this.checkCohostExist = false;
        this.questionnaireObjId = 0;
        this.isSessionCreating = false;
        this.questionnairePopup = false;
        this.queSessionId = 0;
        this.registrationQuestionnaireId = null;
        this.invalidDate = false;
        this.specifyuser = false;
        this.inviteAttendeeShow = false;
        this.notifyAttendeeShow = false;
        this.renameRecordingShow = false;
        this.userToresultsInvitee = [];
        this.usersToInvitee = [];
        this.invitedata = {};
        this.messageto = [];
        this.id = 0;
        this.endPoint = process.env.API_URL + DASHBOARDENDPOINTS.courseDocUploadSession;
    }
    CourseaccountComponent.prototype.editDisplay = function (edit) {
        if (edit) {
            return "block";
        }
        else {
            return "none";
        }
    };
    CourseaccountComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.showSpinner = true;
        this.loadData();
        var s2 = this.dashboardService.userSummary1().subscribe(function (data) { _this.userId = data.userDetailsId; }, function (error) {
            _this.handleError(error);
        });
        this.subscriptions.push(s2);
    };
    CourseaccountComponent.prototype.searchusers = function (event) {
        var _this = this;
        var ss2 = this.dashboardService.userTo(event.query).subscribe(function (data) {
            console.log(data);
            _this.usersTo = data;
            _this.userToresults = _this.usersTo.map(function (user) {
                return {
                    username: user.content,
                    userDetailsId: user.entityId
                };
            });
            console.log(_this.userToresults);
        }, function (error) {
            _this.handleError(error);
        });
        this.subscriptions.push(ss2);
    };
    CourseaccountComponent.prototype.addCoHostSave = function () {
        var _this = this;
        if (this.sessionCoHostId.length > 0) {
            var cohostBody = {
                sessionCoHostId: this.sessionCoHostId[0].userDetailsId,
                sessionId: this.selectedSessionId
            };
            var speakerBody = {
                sessionParticipantId: this.sessionCoHostId[0].userDetailsId,
                sessionId: this.selectedSessionId
            };
            if (this.hostOrSpeaker == 'Host') {
                var ss3 = this.dashboardService.addCoHost(cohostBody).subscribe(function (data) {
                    console.log(data);
                    _this.addCoHostShow = false;
                    _this.createInfoAlert("Co-host added successfully");
                    _this.loadData();
                }, function (error) {
                    _this.addCoHostShow = false;
                    _this.handleError(error);
                });
                this.subscriptions.push(ss3);
            }
            else {
                var ss3 = this.dashboardService.addSpeaker(speakerBody).subscribe(function (data) {
                    console.log(data);
                    _this.addCoHostShow = false;
                    _this.createInfoAlert("Speaker added successfully");
                    _this.loadData();
                }, function (error) {
                    _this.addCoHostShow = false;
                    _this.handleError(error);
                });
                this.subscriptions.push(ss3);
            }
        }
    };
    CourseaccountComponent.prototype.deleteCohost = function (userId, courseId) {
        var _this = this;
        this.confirmationService.confirm({
            message: "<b>Remove Co-host?</b>",
            header: 'Confirmation',
            icon: 'fa fa-question-circle',
            accept: function () {
                _this.showSpinner = true;
                var body = {
                    sessionCoHostId: userId,
                    sessionId: courseId
                };
                var ss1 = _this.dashboardService.removeCoHost(body).subscribe(function (data) {
                    console.log(data);
                    _this.createInfoAlert("Co-host deleted successfully");
                    _this.loadData();
                }, function (error) {
                    _this.handleError(error);
                });
                _this.subscriptions.push(ss1);
            },
            reject: function () {
                _this.showSpinner = false;
            }
        });
    };
    CourseaccountComponent.prototype.addCoHostClose = function () {
        this.addCoHostShow = false;
    };
    CourseaccountComponent.prototype.addCoHost = function (courseId) {
        this.sessionCoHostId = null;
        this.checkCohostExist = false;
        this.hostOrSpeaker = "Host";
        this.selectedSessionId = courseId;
        this.addCoHostShow = true;
    };
    CourseaccountComponent.prototype.hostOrSpeakerChange = function (e, type) {
        if (type == 'Host') {
            this.hostOrSpeaker = "Host";
        }
        else {
            this.hostOrSpeaker = "Speaker";
        }
    };
    CourseaccountComponent.prototype.addSpeaker = function (courseId) {
        this.sessionCoHostId = null;
        this.checkCohostExist = true;
        this.hostOrSpeaker = "Speaker";
        this.selectedSessionId = courseId;
        this.addCoHostShow = true;
    };
    CourseaccountComponent.prototype.deleteSpeaker = function (userId, courseId) {
        var _this = this;
        this.confirmationService.confirm({
            message: "<b>Remove Speaker?</b>",
            header: 'Confirmation',
            icon: 'fa fa-question-circle',
            accept: function () {
                _this.showSpinner = true;
                var body = {
                    sessionParticipantId: userId,
                    sessionId: courseId
                };
                var ss1 = _this.dashboardService.removeSpeaker(body).subscribe(function (data) {
                    console.log(data);
                    _this.createInfoAlert("Speaker deleted successfully");
                    _this.loadData();
                }, function (error) {
                    _this.handleError(error);
                });
                _this.subscriptions.push(ss1);
            },
            reject: function () {
                _this.showSpinner = false;
            }
        });
    };
    CourseaccountComponent.prototype.onSelectCoHost = function () {
    };
    CourseaccountComponent.prototype.onUnselectCoHost = function () {
    };
    CourseaccountComponent.prototype.validUptoSelected = function () {
        this.invalidDate = false;
    };
    CourseaccountComponent.prototype.addPromoCode = function (course) {
        var _this = this;
        this.invalidDate = false;
        console.log(course.promo);
        if (moment(course.promo.promoValid) > moment(course.courseEndDTime)) {
            this.invalidDate = true;
        }
        else {
            this.addCouponCode.couponCode = course.promo.promoCode;
            this.addCouponCode.discountPercentage = course.promo.discount.toString();
            this.addCouponCode.discountPercentage = this.addCouponCode.discountPercentage.replace("%", "");
            this.addCouponCode.targetId = course.courseId;
            this.addCouponCode.validityUpto = moment(course.promo.promoValid).format('MM/DD/YYYY').toString();
            this.showSpinner = true;
            this.dashboardService.addCouponCode(this.addCouponCode).subscribe(function (data) {
                console.log(data);
                _this.loadData();
                _this.showSpinner = true;
                _this.promoAdded = true;
            }, function (error) {
                _this.handleError(error);
                _this.showSpinner = false;
            });
        }
    };
    // discountKeyup(promo) {
    //     if (promo.discount != "") {
    //         promo.discount = promo.discount.replace("%", "") + "%";
    //     }
    // }
    CourseaccountComponent.prototype.deleteCoupon = function (couponId) {
        var _this = this;
        this.showSpinner = true;
        this.dashboardService.deleteCouponCode(couponId).subscribe(function (data) {
            console.log(data);
            _this.loadData();
            _this.addCouponCode.couponCode = "";
            _this.addCouponCode.discountPercentage = "";
            _this.addCouponCode.targetId = 0;
            _this.addCouponCode.validityUpto = "";
            _this.showSpinner = false;
        }, function (error) {
            _this.handleError(error);
            _this.showSpinner = false;
        });
    };
    CourseaccountComponent.prototype.inviteAttendeeClick = function (courseId) {
        this.id = courseId;
        this.inviteAttendeeShow = true;
    };
    CourseaccountComponent.prototype.notifyAttendeeClick = function (courseId) {
        this.id = courseId;
        this.notifyAttendeeShow = true;
    };
    CourseaccountComponent.prototype.handleChange1 = function (evt) {
        var target = evt.target;
        if (target.checked) {
            this.specifyuser = false;
        }
    };
    CourseaccountComponent.prototype.handleChange2 = function (evt) {
        var target = evt.target;
        if (target.checked) {
            this.specifyuser = true;
        }
    };
    CourseaccountComponent.prototype.submit = function (type) {
        var _this = this;
        this.showSpinner = true;
        var arrTo = [];
        if (type == 'Invite') {
            this.messageto.forEach(function (element) {
                arrTo.push(element.emailId);
            });
        }
        this.invitedata.emailIds = arrTo;
        this.invitedata.courseId = this.id;
        this.invitedata.subject = (type == 'Invite') ? "Course Invite" : "Notification from tutor";
        this.invitedata.isInviteAttendeeInMyNetowrk = !this.specifyuser;
        this.invitedata.url = process.env.HOST_URL + "?accessPage=public/viewsession?sessionId=" + this.id;
        if (type == 'Invite') {
            var s1 = this.dashboardService.courseInvite(this.invitedata).subscribe(function (data) {
                console.log(data);
                _this.inviteAttendeeClose();
                _this.showSpinner = false;
                _this.msgTitle = "Success";
                _this.msgContent = "Invitation Sent!!";
                _this.popUp = true;
                _this.messageto = [];
                _this.invitedata = {};
            }, function (error) {
                _this.showSpinner = false;
                _this.inviteAttendeeClose();
                _this.handleError(error);
            });
            this.subscriptions.push(s1);
        }
        else {
            var s1 = this.dashboardService.courseNotification(this.invitedata).subscribe(function (data) {
                console.log(data);
                _this.notifyAttendeeClose();
                _this.showSpinner = false;
                _this.msgTitle = "Success";
                _this.msgContent = "Notification Sent!!";
                _this.popUp = true;
                _this.messageto = [];
                _this.invitedata = {};
            }, function (error) {
                _this.notifyAttendeeClose();
                _this.showSpinner = false;
                _this.handleError(error);
            });
            this.subscriptions.push(s1);
        }
    };
    CourseaccountComponent.prototype.searchInviteeusers = function (event) {
        var _this = this;
        var s2 = this.dashboardService.userTo(event.query).subscribe(function (data) {
            console.log(data);
            _this.usersToInvitee = data;
            _this.userToresultsInvitee = _this.usersToInvitee.map(function (user) {
                return {
                    username: user.content,
                    emailId: user.entityId
                };
            });
            console.log(_this.userToresultsInvitee);
        }, function (error) {
            _this.handleError(error);
        });
        this.subscriptions.push(s2);
    };
    CourseaccountComponent.prototype.inviteAttendeeClose = function () {
        this.inviteAttendeeShow = false;
        this.invitedata = {};
        this.userToresultsInvitee = [];
    };
    CourseaccountComponent.prototype.notifyAttendeeClose = function () {
        this.notifyAttendeeShow = false;
        this.invitedata = {};
        this.userToresultsInvitee = [];
    };
    CourseaccountComponent.prototype.renameRecordingClose = function () {
        this.renameRecordingShow = false;
        this.recordingNewName = "";
    };
    CourseaccountComponent.prototype.renameRecordingPopupopen = function (rec) {
        this.recordingObj.videoId = rec.videoId;
        this.videoIdForRename = rec.videoId;
        this.recordingNewName = rec.displayName;
        this.renameRecordingShow = true;
    };
    CourseaccountComponent.prototype.renameRecordingSubmit = function () {
        var _this = this;
        var that = this;
        this.showSpinner = true;
        if (this.videoIdForRename > 0) {
            this.recordingObj.renamedVideo = this.recordingNewName;
            var renameRecordingSub = this.dashboardService.renameRecording(this.recordingObj).subscribe(function (data) {
                console.log(data);
                _this.pagedItems.forEach(function (element) {
                    if (element.courseId == that.recordingObj.sessionId) {
                        element.sessionVideos.forEach(function (sessionVid) {
                            if (sessionVid.videoId == that.recordingObj.videoId) {
                                sessionVid.displayName = that.recordingNewName;
                            }
                        });
                    }
                });
                _this.renameRecordingShow = false;
                _this.showSpinner = false;
            }, function (error) {
                _this.renameRecordingShow = false;
                _this.handleError(error);
            });
            this.subscriptions.push(renameRecordingSub);
        }
    };
    CourseaccountComponent.prototype.docUploadErr = function (e, course) {
        console.log('doc', e);
        this.docErr(JSON.parse(e.xhr.responseText));
    };
    CourseaccountComponent.prototype.onBeforeSend = function (event) {
        console.log('doc', event);
        var currentUser = localStorage.getItem('authorization');
        event.xhr.setRequestHeader("Authorization", currentUser);
        //event.formData.append('file', event.file, event.file.name);
    };
    CourseaccountComponent.prototype.onBeforeUpload = function (event, course) {
        console.log('doc', event);
        console.log('course', course);
        if (course.hasFile && course.checkFile) {
            return;
        }
        else {
            event.xhr.abort();
        }
    };
    CourseaccountComponent.prototype.fileSelectToUpload = function (e, course) {
        console.log('e', e);
        console.log('c', course);
        setTimeout(function () {
            $("#fileUpload-" + course.courseId).find(".ui-fileupload-buttonbar").find("button:eq(1)").attr("disabled", "true");
        }, 500);
        course.hasFile = true;
    };
    CourseaccountComponent.prototype.onClearFile = function (course) {
        course.hasFile = false;
        course.checkFile = false;
    };
    CourseaccountComponent.prototype.checkBoxEvent = function (e, course) {
        console.log('e', e);
        console.log('coures', course);
        if (course.hasFile != undefined && course.hasFile) {
            if (e.target.checked) {
                course.checkFile = true;
                $("#fileUpload-" + course.courseId).find(".ui-fileupload-buttonbar").find("button:eq(1)").removeAttr("disabled");
            }
            else {
                $("#fileUpload-" + course.courseId).find(".ui-fileupload-buttonbar").find("button:eq(1)").attr("disabled", "true");
                course.checkFile = false;
            }
        }
    };
    CourseaccountComponent.prototype.docUploadComplete = function () {
        this.showSpinner = true;
        this.loadData();
    };
    CourseaccountComponent.prototype.getEndPoint = function (courseId) {
        return this.endPoint + "/" + courseId;
    };
    CourseaccountComponent.prototype.downloadDoc = function (courseId, slidedeck) {
        var _this = this;
        var loader = $("#courseId-" + courseId);
        if (loader.css("display") == "none") {
            loader.css("display", "block");
            loader.parents("fileIconWrap").css("cursor", "default");
            var name_1 = (slidedeck != null && slidedeck != undefined) ? slidedeck : 'doc';
            var doc = this.dashboardService.getDoc(courseId).subscribe(function (data) {
                console.log("doc", data["_body"]);
                var blob = new Blob([data["_body"]], { type: data.headers.get('Content-Type') });
                //saveAs(blob, "tset.jpg");
                var url = window.URL.createObjectURL(blob);
                var a = document.createElement('a');
                document.body.appendChild(a);
                a.setAttribute('style', 'display: none');
                a.href = url;
                a.download = name_1;
                a.click();
                window.URL.revokeObjectURL(url);
                a.remove();
                loader.css("display", "none");
                loader.parents("fileIconWrap").css("cursor", "pointer");
            }, function (error) {
                loader.css("display", "none");
                loader.parents("fileIconWrap").css("cursor", "pointer");
                _this.handleError(error);
            });
            this.subscriptions.push(doc);
        }
    };
    CourseaccountComponent.prototype.loadData = function () {
        var _this = this;
        this.showSpinner = true;
        var s1 = this.dashboardService.onlineCourses().subscribe(function (data) {
            console.log(data);
            _this.allcoursesdata = data;
            _this.balance = _this.allcoursesdata.earning - _this.allcoursesdata.payout;
            _this.allcourses = data.courses;
            if (localStorage.getItem('timezone')) {
                _this.timezone = localStorage.getItem('timezone');
            }
            if (_this.timezone) {
                _this.timeZonechange(_this.timezone);
            }
            _this.allcourses.forEach(function (element) {
                console.log(element);
                console.log(_this.timezone);
                element.displayStartDateOnlyConverted = _this.timeZoneConverstionService.convertTimezone(_this.timezone, 'date', element.courseStartDTime);
                element.timeZoneConverted = _this.timezone;
                element.displayStopDateOnlyConverted = _this.timeZoneConverstionService.convertTimezone(_this.timezone, 'date', element.courseEndDTime);
                element.startTime.displayConverted = _this.timeZoneConverstionService.convertTimezone(_this.timezone, 'time', element.courseStartDTime);
                element.endTime.displayConverted = _this.timeZoneConverstionService.convertTimezone(_this.timezone, 'time', element.courseEndDTime);
                element.promo = { promoCode: "", promoValid: "", discount: "" };
            });
            _this.setPage(_this.currentPage);
            _this.showSpinner = false;
        }, function (error) {
            _this.handleError(error);
        });
        this.subscriptions.push(s1);
    };
    CourseaccountComponent.prototype.setPage = function (page) {
        console.log("page", page);
        this.currentPage = page;
        if (page < 1 || page > this.pager.totalPages) {
            return;
        }
        // get pager object from service
        this.pager = this.pagerService.getPager(this.allcourses.length, page, 20);
        // get current page of items
        this.pagedItems = this.allcourses.slice(this.pager.startIndex, this.pager.endIndex + 1);
        if (this.pagedItems.length === 0) {
            this.SessionMsg = "You do not have any session yet, please create one and share knowledge.";
        }
        window.scrollTo(0, 0);
        this.showSpinner = false;
    };
    CourseaccountComponent.prototype.payout = function () {
        var _this = this;
        this.showSpinner = true;
        this.confirmationService.confirm({
            message: "Do you really want to withdraw now?",
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: function () {
                var s3 = _this.dashboardService.payoutCourse(_this.userId).subscribe(function (data) {
                    console.log("Does it have paypal configuration error? =" + data.configurePaypal);
                    if (data.configurePaypal) {
                        _this.showSpinner = false;
                        console.log("show confirmation");
                        _this.confirmationService.confirm({
                            message: "In order to process your payout request,you need to activate your payment information under [my account]. Do you want to configure it now?",
                            header: 'Confirmation',
                            icon: 'pi pi-exclamation-triangle',
                            accept: function () {
                                _this.router.navigate(['dashboard/myaccount']);
                            },
                            reject: function () {
                                // do nothing
                            }
                        });
                    }
                    else {
                        console.log("Paypal configuration active, you can proceed");
                        _this.dashboardService.onlineCourses().subscribe(function (data) {
                            console.log(data);
                            _this.allcoursesdata = data;
                            _this.balance = _this.allcoursesdata.earning - _this.allcoursesdata.payout;
                            _this.allcourses = data.courses;
                            _this.showSpinner = false;
                        }, function (error) {
                            _this.showSpinner = false;
                            _this.handleError(error);
                        });
                    }
                }, function (error) {
                    _this.showSpinner = false;
                    _this.handleError(error);
                });
                _this.subscriptions.push(s3);
            },
            reject: function () {
                _this.showSpinner = false;
            }
        });
    };
    CourseaccountComponent.prototype.cancleCourse = function (id) {
        var _this = this;
        if (confirm("Do you really want to cancel this course?")) {
            this.showSpinner = true;
            var s4 = this.dashboardService.courseCancle(id).subscribe(function (data) {
                var s5 = _this.dashboardService.onlineCourses().subscribe(function (data) {
                    console.log(data);
                    _this.allcoursesdata = data;
                    _this.balance = _this.allcoursesdata.earning - _this.allcoursesdata.payout;
                    _this.allcourses = data.courses;
                    _this.loadData();
                }, function (error) {
                    _this.showSpinner = false;
                    _this.handleError(error);
                });
                _this.subscriptions.push(s5);
            }, function (error) {
                _this.showSpinner = false;
                _this.handleError(error);
            });
            this.subscriptions.push(s4);
        }
    };
    CourseaccountComponent.prototype.displayCourseRecordings = function (course) {
        this.courseRecordings = course.sessionVideos;
        this.recordingObj.sessionId = course.courseId;
        this.showCourseRecordings = true;
    };
    CourseaccountComponent.prototype.resetShowCourseRecordings = function () {
        this.courseRecordings = [];
        this.showCourseRecordings = false;
    };
    CourseaccountComponent.prototype.closeRecordingsDialog = function () {
        this.resetShowCourseRecordings();
    };
    CourseaccountComponent.prototype.openRecordingWindow = function (recordingURL) {
        window.open(recordingURL, "Course Recording", "width=" + this.courseRecordingsWindowWidth + ",height=" + this.courseRecordingsWindowHeight);
    };
    CourseaccountComponent.prototype.QuestionnaireEvent = function (type, Id, course) {
        this.queSessionId = Id;
        if (type == 'add') {
            this.questionnairePopup = true;
        }
        else if (type == 'edit') {
            this.questionnaireObjId = Id;
            this.questionnairePopup = true;
        }
    };
    CourseaccountComponent.prototype.questionnaireClose = function (e) {
        console.log('mysessionQuest', e);
        if (e.identifier != undefined && e.identifier > 0) {
            var that_1 = this;
            this.pagedItems.forEach(function (element) {
                if (element.courseId == that_1.queSessionId) {
                    element.registrationQuestionnaireId = e.identifier;
                }
            });
        }
        if (e.isdeleted) {
            var nthat_1 = this;
            this.pagedItems.forEach(function (element) {
                if (element.courseId == nthat_1.queSessionId) {
                    element.registrationQuestionnaireId = null;
                }
            });
        }
        this.isSessionCreating = false;
        this.questionnaireObjId = 0;
        this.queSessionId = 0;
        this.questionnairePopup = false;
    };
    CourseaccountComponent.prototype.handleToggleChange = function (course, e) {
        var _this = this;
        this.showSpinner = true;
        var isChecked = e.checked;
        var ss5 = this.dashboardService.registrationPossible(course.courseId, isChecked).subscribe(function (data) {
            console.log(data);
            course.isRegistrationPossible = isChecked;
            _this.showSpinner = false;
        }, function (error) {
            _this.showSpinner = false;
            _this.handleError(error);
        });
        this.subscriptions.push(ss5);
    };
    CourseaccountComponent.prototype.timeZonechange = function (data) {
        var _this = this;
        console.log(data);
        this.allcourses.forEach(function (element) {
            //console.log(element);
            element.displayStartDateOnlyConverted = _this.timeZoneConverstionService.convertTimezone(data, 'date', element.courseStartDTime);
            element.timeZoneConverted = data;
            element.displayStopDateOnlyConverted = _this.timeZoneConverstionService.convertTimezone(data, 'date', element.courseEndDTime);
            element.startTime.displayConverted = _this.timeZoneConverstionService.convertTimezone(data, 'time', element.courseStartDTime);
            element.endTime.displayConverted = _this.timeZoneConverstionService.convertTimezone(data, 'time', element.courseEndDTime);
        });
        localStorage.setItem('timezone', data);
    };
    CourseaccountComponent.prototype.convertTimezone = function (timezone, type, datetime) {
        if (type == 'date') {
            var setdate = moment(datetime, 'YYYY-MM-DD HH:mm Z');
            return setdate.tz(timezone).format('MM/DD/YYYY');
        }
        else {
            var setdate = moment(datetime + '+00:00', 'HH:mmZ');
            return setdate.tz(timezone).format('HH:mm');
        }
    };
    CourseaccountComponent.prototype.docErr = function (err) {
        if (err.url == undefined) {
            err.url = "Intenal Error";
        }
        this.handleError(err);
    };
    CourseaccountComponent.prototype.createInfoAlert = function (alert) {
        var infoAlert = {
            isInfo: true,
            infoMessage: alert,
            url: "not required"
        };
        this.handleError(infoAlert);
    };
    CourseaccountComponent.prototype.handleError = function (error) {
        this.showSpinner = false;
        var url = error.url;
        if (url == undefined) {
            return;
        }
        this.errorHandlerService.throwError(error);
    };
    CourseaccountComponent.prototype.ngOnDestroy = function () {
        this.subscriptions.forEach(function (element) {
            element.unsubscribe();
        });
    };
    return CourseaccountComponent;
}());
export { CourseaccountComponent };
//# sourceMappingURL=courseaccount.component.js.map